<template>
  <div>
    <div class="container">
      <div
        v-if="isLoading"
        class="skeleton-load"
        style="width: 100%; min-height: 12vh; border-radius: 16px; margin: 1rem auto;"
      ></div>
      <div
        v-if="isLoading"
        class="skeleton-load"
        style="width: 100%; min-height: 12vh; border-radius: 16px; margin: 1rem auto;"
      ></div>
      <div
        v-if="isLoading"
        class="skeleton-load"
        style="width: 100%; min-height: 12vh; border-radius: 16px; margin: 1rem auto;"
      ></div>
      <div
        v-if="isLoading"
        class="skeleton-load"
        style="width: 100%; min-height: 12vh; border-radius: 16px; margin: 1rem auto;"
      ></div>
    </div>
    <section class="schedule">
      <div class="schedule-tabs" v-if="!isLoading">
        <div class="container">
          <button class="schedule-tabs--trigger active">
            <h2 class="schedule-title">Agenda</h2>
          </button>
        </div>
      </div>
      <div class="schedules-tabs-content" v-if="!isLoading">
        <span v-if="events.length > 0">
          <div
            v-for="(item, key) in events"
            :key="key"
            class="schedule-item"
            @click="displayEvent($event, item)"
          >
            <div class="container">
              <div class="schedule-item__date">
                <p>{{getHumanDateOfTimestamp(item.timestamp)}}hrs</p>
              </div>
              <div class="schedule-item__content">
                <div class="schedule-item__content-information">
                  <p class="schedule-item__title">{{ item.title }}</p>
                  <div class="points-list">
                    <div class="point-information" :data-point="item.type">{{ item.display_type }}</div>

                    <a
                      v-if="isLive(item.timestamp, item.timestamp_end)"
                      :id="item.id"
                      :href="item.liveConfig.redirect"
                      class="point-information"
                      data-point="live"
                    >EN VIVO</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
        <div class="container" v-else>
          <span class="mt-3">No hay eventos agendados en este momento</span>
        </div>
      </div>
    </section>
    <simple-modal v-model="showEvent" @onClose="showEvent = false" size="responsive">
      <template slot="body">
        <ContentModal v-if="showEvent" :item="eventSelected" />
      </template>
    </simple-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import {
  getTimestampFormat,
  getCurrenTimestampFormat,
  getHumanDateOfTimestamp
} from "../helpers";
import SimpleModal from "simple-modal-vue";
import ContentModal from "./ModalEvent.vue";

export default {
  name: "Schedule",
  components: {
    SimpleModal,
    ContentModal
  },
  data() {
    return {
      showEvent: false,
      inRegister: false,
      isLoading: true,
      events: [],
      eventSelected: {}
    };
  },
  async created() {
    try {
      this.events = await firebase
        .database()
        .ref("events/")
        .once("value")
        .then(snapshot => {
          let response = snapshot.val();
          let r = response.filter(
            e =>
              getTimestampFormat(e.timestamp_end) > getCurrenTimestampFormat()
          );

          r = r.sort((a, b) => {
            let x = getTimestampFormat(a.timestamp);
            let y = getTimestampFormat(b.timestamp);
            return x - y;
          });
          return r;
        });

      this.isLoading = false;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    displayEvent(event, item) {
      if (!(event.target.id !== null && event.target.id !== "")) {
        this.eventSelected = item;
        this.showEvent = true;
      }
    },
    isLive(start, end) {
      const today = getCurrenTimestampFormat();
      const starDate = getTimestampFormat(start);
      const dueDate = getTimestampFormat(end);
      return today > starDate && today < dueDate;
    },
    getHumanDateOfTimestamp
  }
};
</script>


    